module.exports = {
      id: "slider-left-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#slider-left-arrow",
      toString: function () {
        return this.url;
      }
    }